function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
  id: "broadband-mid_svg__a",
  "data-name": "Wifi_ic_mid",
  viewBox: "0 0 192 192"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "ICON"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "<Pfad>",
  cx: 96,
  cy: 132,
  r: 8,
  fill: "#666"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M20 59.5a107.43 107.43 0 01152 0M42 82.51a76.76 76.76 0 01108.6 0M64.6 105.08a44.62 44.62 0 0163.12 0",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "ICON"
}, /*#__PURE__*/React.createElement("use", {
  "data-name": "Wifi_ic_mid",
  width: 192,
  height: 192,
  xlinkHref: "#broadband-mid_svg__a"
}));

var SvgBroadbandMid = function SvgBroadbandMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgBroadbandMid;